import { createContext, useContext, useMemo } from "react";

/* Small fetch wrapper shared by every page. */
const ApiContext = createContext(null);

export function ApiProvider({ base, children }) {
  const api = useMemo(() => {
    const request = async (path, { method = "GET", params, body } = {}) => {
      const url = new URL(base + path);
      if (params) Object.entries(params).forEach(([k, v]) => v != null && url.searchParams.set(k, v));
      let res;
      try {
        res = await fetch(url, {
          method,
          credentials: "include",
          headers: body ? { "Content-Type": "application/json" } : undefined,
          body: body ? JSON.stringify(body) : undefined,
        });
      } catch {
        throw new Error(`the API at ${base} isn't reachable`);
      }
      const data = await res.json().catch(() => ({}));
      // session ended (logged out, logged in elsewhere, or expired): tell the app to show the sign-in screen
      if (res.status === 401 && !path.startsWith("/api/auth/")) window.dispatchEvent(new CustomEvent("ae2c:signed-out"));
      if (!res.ok) throw new Error(data.error || data.message || `server replied ${res.status}`);
      return data;
    };
    return {
      base,
      get: (path, params) => request(path, { params }),
      request: (path, method, body) => request(path, { method, body }),
      post: (path, body) => request(path, { method: "POST", body }),
    };
  }, [base]);
  return <ApiContext.Provider value={api}>{children}</ApiContext.Provider>;
}

export const useApi = () => useContext(ApiContext);
